export const MedicineData = [
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },
    {
        medname: 'ABC',
        dosage: '125 mg',
        frequency: 'Morning - Noon - Night',
    },

];
